import { cn } from './cn';

/** "Live" marker: a teal dot with a tiny navy satellite orbiting it (still under reduced motion). */
export function LiveDot({ className }: { className?: string }) {
  return (
    <span aria-hidden className={cn('relative inline-block size-3.5 shrink-0', className)}>
      <span className="absolute inset-[3.5px] rounded-full bg-brand" />
      <span className="absolute inset-0 animate-orbit-slow motion-reduce:animate-none">
        <span className="absolute left-1/2 top-0 size-[3px] -translate-x-1/2 rounded-full bg-navy" />
      </span>
    </span>
  );
}
